// Filters the recipe tiles on the Recipes page without a reload. Loaded only by sections/ru-blog.liquid.
//
// A button's data-ru-filter is a lower-case mushroom name ("" means All). A tile's data-ru-mushrooms lists the
// names found in its title, each followed by "|". Tiles that do not match are hidden.
// The first visible tile is the wide one (data-ru-lead, which ru.css spans across both columns on computers), and
// its photo gets the wide `sizes` as well: otherwise the browser would keep the file picked for a half-width tile.
// The status line's words come from the locale files: the section prints them on [data-ru-status] as
// data-ru-status-none, -one and -other ("{{ count }}" is replaced here).

const ROOT = '[data-ru-recipe-filter]';

function showOnly(root, key) {
  const list = root.querySelector('[data-ru-sizes-tile]');
  let lead = null;
  let shown = 0;
  for (const item of root.querySelectorAll('[data-ru-item]')) {
    const matches = key === '' || item.dataset.ruMushrooms.split('|').includes(key);
    item.hidden = !matches;
    item.removeAttribute('data-ru-lead');
    if (!matches) continue;
    shown += 1;
    lead ??= item;
  }
  lead?.setAttribute('data-ru-lead', '');
  for (const item of root.querySelectorAll('[data-ru-item]:not([hidden])')) {
    const photo = item.querySelector('img');
    if (photo) photo.sizes = item === lead ? list.dataset.ruSizesLead : list.dataset.ruSizesTile;
  }
  const status = root.querySelector('[data-ru-status]');
  if (status) {
    const words = status.dataset;
    status.textContent =
      shown === 0 ? words.ruStatusNone : shown === 1 ? words.ruStatusOne : words.ruStatusOther.replace('{{ count }}', String(shown));
    // announced to screen readers always; only seen when there is nothing to show
    status.classList.toggle('visually-hidden', shown > 0);
  }
}

// One listener on the document, so it keeps working if the theme editor re-renders the section.
document.addEventListener('click', (event) => {
  const button = event.target instanceof Element ? event.target.closest('[data-ru-filter]') : null;
  const root = button?.closest(ROOT);
  if (!button || !root) return;
  for (const other of root.querySelectorAll('[data-ru-filter]')) {
    other.setAttribute('aria-pressed', String(other === button));
  }
  showOnly(root, button.dataset.ruFilter);
});
